import { getStore } from '../store/stores-repository'
import { ROUTING_STORE, NAVIGATION_MENU_STORE } from '../store/stores'

/**
 * Возвращает baseURL из global.build
 */
export const getBaseURL = () => {
    let baseURL = global.build.baseURL || ''

    if (baseURL === '/') {
        baseURL = ''
    }

    if (baseURL) {
        if (!baseURL.startsWith('/')) {
            baseURL = `/${baseURL}`
        }
        if (baseURL.endsWith('/')) {
            baseURL = baseURL.substr(0, baseURL.length - 1)
        }
    }
    return baseURL
}

/**
 * Переходит на указанный роут
 * @param {string} path
 */
export const goTo = path => {
    const routingStore = getStore(ROUTING_STORE)
    const navigationMenuStore = getStore(NAVIGATION_MENU_STORE)
    routingStore.push(path)
    navigationMenuStore.synchronizeWithRoute()
}
